// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3XA5o","col":"CardReaderDesc_col__vD8JG","label":"CardReaderDesc_label__1ZT1G"};